import { useContext, useEffect, useState } from "react";
import FilterSelect from "../FilterSelect";
import { AppContext } from "../../../context/AppContext";
import { SEARCH_PARAMS } from "../../../utils/SearchParams";
import { useCustomSearchParams } from "../../hooks/useCustomSearchParams";
import "./FilterBy.scss";

const NO_SEARCH = "NO_SEARCH";

const FilterBy = () => {
  const {
    filterByData,
    selectedFilterBy,
    selectedFilterByLabel,
    filterBySearchParams,
    changeSelectedFilterBy,
    changeSelectedFilterByLabel,
    changeFilterBySearchParams,
    changeFilterByViaSearch,
  } = useContext(AppContext);
  const { get, set, setMultiple } = useCustomSearchParams();

  const [selectedValue, setSelectedValue] = useState(
    selectedFilterByLabel || "",
  );

  const handleOnChange = (obj, viaSearch = false) => {
    changeSelectedFilterBy(obj.value);
    changeSelectedFilterByLabel(obj.label);

    if (obj.value === NO_SEARCH || obj.value === "ALL") {
      changeFilterByViaSearch(false);
    } else {
      changeFilterByViaSearch(Boolean(viaSearch));
    }

    if (obj.value === NO_SEARCH) {
      changeFilterBySearchParams(obj.value);
    } else if (obj.value === "ALL") {
      changeFilterBySearchParams(NO_SEARCH);
    }
  };

  useEffect(() => {
    if (filterByData) {
      // While the user is actively searching, filterByData is being refetched
      // for the search term. Re-deriving the selection here would resolve back
      // to the default option (selectedFilterBy is still "ALL" until the user
      // commits a pick), push that default label into FilterSelect's `value`,
      // and wipe the search box mid-search. Skip re-derivation in that case.
      const isActivelySearching =
        Boolean(filterBySearchParams) &&
        ![NO_SEARCH, "All funders", "All publishers"].includes(
          filterBySearchParams,
        );
      if (isActivelySearching) return;

      const filterValue =
        selectedFilterBy ||
        get(SEARCH_PARAMS.FILTER_BY) ||
        filterByData[0].value;

      const label = filterByData.find((item) => item.value === filterValue);

      if (label) {
        setSelectedValue(label.label);
        changeSelectedFilterByLabel(label.label);
        changeSelectedFilterBy(label.value);
      }
    }
  }, [filterByData]);

  useEffect(() => {
    if (!selectedFilterBy) return;
    setSelectedValue(selectedFilterByLabel);
  }, [selectedFilterBy, selectedFilterByLabel]);

  return (
    <FilterSelect
      label="Filter by"
      value={selectedValue}
      selectedOptionValue={selectedFilterBy}
      enableInfiniteScroll={true}
      options={filterByData}
      onChange={(value, viaSearch) => handleOnChange(value, viaSearch)}
      showSearchField={true}
    />
  );
};

export default FilterBy;
